export const REPORT_PRODUCT_STOCK_SUMMARY = 'REPORT_PRODUCT_STOCK_SUMMARY';
export const REPORT_PRODUCT_STOCK_ACTIVITY_HISTOGRAM = 'REPORT_PRODUCT_STOCK_ACTIVITY_HISTOGRAM';
export const REPORT_PRODUCT_STOCK_ACTIVITY_TOP_USER = 'REPORT_PRODUCT_STOCK_ACTIVITY_TOP_USER';
export const REPORT_PRODUCT_STOCK_ACTIVITY_REDUCTION = 'REPORT_PRODUCT_STOCK_ACTIVITY_REDUCTION';
export const REPORT_PRODUCT_STOCK_ACTIVITY = 'REPORT_PRODUCT_STOCK_ACTIVITY';
export const REPORT_PRODUCT_STOCK_ACTIVITY_ONE = 'REPORT_PRODUCT_STOCK_ACTIVITY_ONE';

export const REPORT_PRODUCT_DISCOUNT_ACTIVITY_HISTOGRAM = 'REPORT_PRODUCT_DISCOUNT_ACTIVITY_HISTOGRAM';

export const REPORT_SALE_OFFER_ACTIVITY_HISTOGRAM = 'REPORT_SALE_OFFER_ACTIVITY_HISTOGRAM';

/* module cms */
export const REPORT_PRODUCT_TITLE_KEYWORD_LIST = 'REPORT_PRODUCT_TITLE_KEYWORD_LIST';
export const REPORT_PRODUCT_TITLE_ERROR_LIST = 'REPORT_PRODUCT_TITLE_ERROR_LIST';
export const REPORT_PRODUCT_TITLE_HISTOGRAM = 'REPORT_PRODUCT_TITLE_HISTOGRAM';

export const PRODUCT_ROTATION_NEW = 'PRODUCT_ROTATION_NEW';
export const PRODUCT_ROTATION_NEW_TABLE_NEW = 'PRODUCT_ROTATION_NEW_TABLE';
export const PRODUCT_ROTATION_NEW_TABLE_HISTOGRAM = 'PRODUCT_ROTATION_NEW_TABLE_HISTOGRAM';

export const ANALITY_CLIENT_SUMMARY = 'ANALITY_CLIENT_SUMMARY';
export const ANALITY_CLIENT_HISTOGRAM = 'ANALITY_CLIENT_HISTOGRAM';

/* module offers */
export const ANALITY_SALES_OFFER_KEY = 'ANALITY_SALES_OFFER_KEY';

/* module sales */
export const ANALYTIC_SALES_KEY = 'ANALYTIC_SALES_KEY';
export const ANALYTIC_COMPARATIVE_SALES_KEY = 'ANALYTIC_COMPARATIVE_SALES_KEY';

export const INCIDENCE_RESOLUTION_ANALYTIC_KEY = 'INCIDENCE_RESOLUTION_ANALYTIC_KEY';

/* module payment */
export const ANALYTIC_PAYMENT_OPS_KEY = 'ANALYTIC_PAYMENT_OPS_KEY';
export const ANALYTIC_COMPARATIVE_PAYMENT_KEY = 'ANALYTIC_COMPARATIVE_PAYMENT_KEY';
export const ANALYTIC_BUSINESS_KEY = 'ANALYTIC_BUSINESS_KEY';

/* inventory analytics v2 */
export const ANALYTIC_INVENTORY_FLOWS_KEY = 'ANALYTIC_INVENTORY_FLOWS_KEY';
export const ANALYTIC_COMPARATIVE_INVENTORY_FLOWS_KEY = 'ANALYTIC_COMPARATIVE_INVENTORY_FLOWS_KEY';
export const ANALYTIC_INVENTORY_COVERAGE_KEY = 'ANALYTIC_INVENTORY_COVERAGE_KEY';
export const ANALYTIC_COMPARATIVE_INVENTORY_COVERAGE_KEY = 'ANALYTIC_COMPARATIVE_INVENTORY_COVERAGE_KEY';
export const ANALYTIC_INVENTORY_RISK_KEY = 'ANALYTIC_INVENTORY_RISK_KEY';
export const ANALYTIC_PRODUCT_SCORE_KEY = 'ANALYTIC_PRODUCT_SCORE_KEY';
export const ANALYTIC_COMPARATIVE_PRODUCT_SCORE_KEY = 'ANALYTIC_COMPARATIVE_PRODUCT_SCORE_KEY';

export const PAYMENT_LOGS_LIST_KEY = 'PAYMENT_LOGS_LIST_KEY';

/* cancelled orders analytics */
export const ANALYTIC_CANCELLED_ORDERS_KEY = 'ANALYTIC_CANCELLED_ORDERS_KEY';
export const ANALYTIC_CANCELLED_ORDERS_CLIENT_KEY = 'ANALYTIC_CANCELLED_ORDERS_CLIENT_KEY';
export const CANCELLED_ORDERS_BY_CLIENT_KEY = 'CANCELLED_ORDERS_BY_CLIENT_KEY';

export const ANALYTIC_SUPPLIER_SALES_KEY = 'supplier-sales-analytics';

/* customer care actions */
export const CUSTOMER_CARE_ACTIONS_KEY = 'CUSTOMER_CARE_ACTIONS_KEY';

/* customer care actions analytics */
export const ANALYTIC_CUSTOMER_CARE_ACTIONS_KEY = 'ANALYTIC_CUSTOMER_CARE_ACTIONS_KEY';

/* suborder complete customer analytics (Atención al Cliente) */
export const ANALYTIC_SUBORDER_CUSTOMER_KEY = 'ANALYTIC_SUBORDER_CUSTOMER_KEY';
export const CUSTOMER_ROLE_USERS_LIST_KEY = 'CUSTOMER_ROLE_USERS_LIST_KEY';

/* inventory operation analytics */
export const ANALYTIC_INVENTORY_OPERATION_KEY = 'ANALYTIC_INVENTORY_OPERATION_KEY';

/* regional coverage analytics */
export const ANALYTIC_INVENTORY_REGIONAL_COVERAGE_KEY = 'ANALYTIC_INVENTORY_REGIONAL_COVERAGE_KEY';
